import { useState, useEffect } from "react";
import { NavLink } from 'react-router-dom';
// import ImageWithoutRightClick from "../Display/ImageWithoutRightClick";

function TopCardsPage() {

    const [cards, setCards] = useState([]);
    const [nonSetCards, setNonSetCards] = useState([]);
    const [decks, setDecks] = useState(0);
    const [showSetCards, setShowSetCards] = useState(true);
    const [totalCards, setTotalCards] = useState(0)
    const [noCards, setNoCards] = useState(false);

    const [showMore, setShowMore] = useState(20);
    const [listView, setListView] = useState(false);

    const getCards = async() =>{
        const topResponse = await fetch("https://pm-deck-react-only.onrender.com/decks/popular_cards")
        const topData = await topResponse.json()
        console.log(topData)
        const cardsResponse = await fetch("https://pm-deck-react-only.onrender.com/cards")
        if (cardsResponse.ok) {
            const cardsData = await cardsResponse.json()
            const topCards = Object.entries(topData[0])
                .map((cardItem) => {
                    const card = {...cardsData.find(card => card.card_number === parseInt(cardItem[0], 10))}
                    if (card) card["count"] = cardItem[1]
                    console.log(card)
                    return card
                })
            const uniqueTopCards = Object.entries(topData[1])
                .map((cardItem) => {
                    const card = {...cardsData.find(card => card.card_number === parseInt(cardItem[0], 10))}
                    if (card) card["count"] = cardItem[1]
                    return card
                })
            setNonSetCards(typeCards(topCards).sort((a,b) => b.count - a.count))
            setCards(typeCards(uniqueTopCards).sort((a,b) => b.count - a.count))
            // console.log("topCards", topCards)
            // console.log("uniqueTopCards", uniqueTopCards)
        } else {
            setNoCards(true)
        }

        setTotalCards(topData[2])
        setDecks(topData[3])
    };

    const typeCards = (cards) => {
        const typedCards = []
        for (let card of cards){
            if (card.card_type[0] === 1001) {
                card["cardType"] = "Fighter"
            }
            else if (card.card_type[0] === 1002) {
                card["cardType"] = "Aura"
            }
            else if (card.card_type[0] === 1003) {
                card["cardType"] = "Move"
            }
            else if (card.card_type[0] === 1004) {
                card["cardType"] = "Ending"
            }
            else if (card.card_type[0] === 1005) {
                card["cardType"] = "Any Type"
            }
            else if (card.card_type[0] === 1006) {
                card["cardType"] = "Item"
            }
            else if (card.card_type[0] === 1007) {
                card["cardType"] = "Event"
            }
            else if (card.card_type[0] === 1008) {
                card["cardType"] = "Comeback"
            }

            card["effectText"] = card.effect_text.split("//")

            if (card.second_effect_text){
                card["secondEffectText"] = card.second_effect_text.split("//")
            }
            typedCards.push(card)
        }
        return typedCards
    }

    useEffect(() => {
        window.scroll(0, 0);
        document.body.style.overflow = 'auto';
        getCards();
        // getDecks();
        document.title = "Top Cards - CW CardBase"
        return () => {
            document.title = "ComboWeaver CardBase"
        };
    // eslint-disable-next-line
    },[]);

    const handleShowMore = (event) => {
        setShowMore(showMore + 20);
    };

    const handleListView = (event) => {
        setListView(!listView);
        setShowMore(20)
    };

    const handleShowSetCards = (event) => {
        setShowSetCards(!showSetCards);
    };

    const all_cards = showSetCards? cards : nonSetCards


    return (
        <div className="white-space">
            <h1 className="left-h1">Top Cards</h1>
            <h2 className="left">{showSetCards? "Total Number of Public Decks" :"Total Number of Copies in All Public Decks"}</h2>
            {listView?
                <button
                    className="left-top-card"
                    onClick={handleListView}
                >
                    Image View
                </button>:
                <button
                    className="left-top-card"
                    onClick={handleListView}
                >
                    List View
                </button>}

                {showSetCards?
                <button
                    className="left-top-card2"
                    onClick={handleShowSetCards}
                >
                    Total Copies
                </button>:
                <button
                className="left-top-card2"
                onClick={handleShowSetCards}
                >
                    Deck Count
                </button>}

                { all_cards.length == 0 && !noCards?
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                    </div> :
                null}

            {listView?
                <div className="list-page-fill">
                    {all_cards.slice(0, showMore).map(card => {
                        return (
                            <NavLink to={`/cards/${card.card_number}`} className="nav-link glow2 padding-5">
                                    <div className={card.card_class ? `big${card.card_class}5` : "bigNoClass2"}>
                                        <h3 style={{fontWeight: "600", margin: "12px"}}>{card.name}</h3>
                                        <h5 style={{fontWeight: "600", margin: "12px"}}>{card.card_class} {card.cardType}</h5>
                                        {card.effectText.map((line) =>
                                        <h6 style={{fontWeight: "400", margin: "3px 12px"}}>
                                            {line}</h6>)}
                                        {card.secondEffectText?
                                        <>{card.secondEffectText.map((line) =>
                                        <h6 style={{fontWeight: "400", margin: "12px 12px 3px 12px"}}>
                                            {line}</h6>)}</>
                                        :null}
                                        <h5 style={{fontWeight: "600", margin: "12px 12px 0px 12px"}}>
                                            {card.series_name.replaceAll("//", " | ")} &nbsp; {card.card_number}
                                            <span style={{fontSize: "16px"}}>&#11089;</span>
                                            {card.hero_id}
                                        </h5>
                                        { showSetCards?
                                            <h4 style={{fontWeight: "600", margin: "12px 12px 0px 12px"}}>
                                                {card.count} of {decks} Decks - {((card.count)*100 / decks).toFixed(2)}%
                                            </h4>
                                        :
                                            <h4 style={{fontWeight: "600", margin: "12px 12px 0px 12px"}}>
                                                {card.count} Copies of {totalCards} Cards
                                            </h4>
                                        }
                                    </div>
                            </NavLink>
                        );
                    })}
                </div>
            :
            <div className="card-page-fill2">
                {all_cards.slice(0, showMore).map(card => {
                    return (
                            <div className="aligned">
                                <NavLink to={`/cards/${card.card_number}`} className="nav-link glow3 padding-5">
                                    <img className="card-list-card"
                                        title={card.name}
                                        src={card.picture_url ? card.picture_url : "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/logo4p.jpg"}
                                        alt={card.name}/>
                                </NavLink>
                                <h5 className="centered-h5"> {card.name} </h5>
                                { showSetCards?
                                    <h6 className="centered-h5-2">
                                        {card.count} of {decks} Decks - {((card.count)*100 / decks).toFixed(2)}%
                                    </h6>
                                :
                                    <h6 className="centered-h5-2">
                                        {card.count} Copies of {totalCards} Cards
                                    </h6>
                                }

                            </div>
                    );
                })}
            </div>
            }
            {showMore < cards.length ?
                <button
                    variant="dark"
                    style={{ width: "100%"}}
                    onClick={handleShowMore}>
                    Show More Cards ({cards.length - showMore} Remaining)
                </button> : null }
    </div>
    );
}

export default TopCardsPage;
